import { createRouter, createWebHistory } from "vue-router";

import Login from '../Login';
import Dashboard from '../Dashboard';
import Home from '../views/Home/Home';

// App Routes
import bovineRoutes from './app/bovine';
import farmRoutes from './app/farm';
import farmLotRoutes from './app/farmLot';
import ownerRoutes from './app/owner';
import serviceRoutes from './app/service';
import saleRoutes from './app/sale';
import invoiceRoutes from './app/invoice';
import cashflowRoutes from './app/cashflow';
import vetRoutes from './app/vet';
import reportTemplate from './app/reportTemplate';
import jobRoutes from './app/job';

// Admin Routes
import accountRoutes from './admin/account';
import userRoutes from './admin/user';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            component: Dashboard,
            path: '/',
            children: [
                {
                    path: '',
                    name: 'home',
                    component: Home,
                    meta: {
                        pageTitle: 'Home',
                    }
                },
                ...bovineRoutes,
                ...farmRoutes,
                ...farmLotRoutes,
                ...ownerRoutes,
                ...serviceRoutes,
                ...saleRoutes,
                ...invoiceRoutes,
                ...cashflowRoutes,
                ...vetRoutes,
                ...reportTemplate,
                ...jobRoutes,

                // Admin
                ...accountRoutes,
                ...userRoutes,

                {
                    path: '/termos-e-privacidade',
                    name: 'terms-and-privacy',
                    component: () => import(/* webpackChunkName: "terms" */ '../views/Terms/Terms.vue'),
                    meta: {
                        pageTitle: 'Termos e Privacidade',
                        breadcrumb: [{ label: 'Termos e Privacidade' }],
                    },
                },
            ],
        }
    ],
});

export default router;
